export default __webpack_public_path__ + "static/media/orthopedics-icon.661cb917.svg";